import { useCallback, useState, type ReactNode } from 'react';
import { FeatureLoading } from '../features/feature-skeleton';
import { WorkspaceReadyContext } from './workspace-entry-context';

/** Mount authenticated reads behind one continuous entry surface; reveal only after settlement. */
export function WorkspaceEntry({ children }: { children: ReactNode }) {
  const [ready, setReady] = useState(false);
  const reveal = useCallback(() => setReady(true), []);
  return (
    <WorkspaceReadyContext.Provider value={reveal}>
      {!ready && (
        <main className="workspace-entry-loading">
          <FeatureLoading label="업무 화면을 준비하고 있습니다." />
        </main>
      )}
      <div
        className={ready ? 'workspace-entry-ready' : 'workspace-entry-pending'}
        inert={!ready}
        aria-hidden={!ready}
      >
        {children}
      </div>
    </WorkspaceReadyContext.Provider>
  );
}
